import React from "react";
import { useFormContext } from "react-hook-form";
import classNames from "classnames";
import { debounce } from "lodash";
import SVG from 'components/base/SVG';
import Tooltip from "../../app/components/Tooltip";
import css from "./style.scss";

const TextField = ({ name, label, placeholder = label, type = "text", required = true , numbers = false , decimal = false,  maxLength=null, showHint = '',   
    /** 
     * This is optional property to hide the error message  
     * Currently used in case of password field where we show custom error component
     * */
    hideErrorMsg,
    delayOnChangeValidation = 0,
    successText,
    // Function call it with onchange value to get if we should avoid delay
    avoidDelay
  }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const {
    register,
    trigger,
    setValue,
    formState: { errors, touchedFields,isSubmitted },
  } = useFormContext();
  const isPassword = type === "password";
  const delayedValidateField = debounce((name) => {
    trigger(name);
  }, delayOnChangeValidation);
  return (
    <div className={classNames(css.clsFormGroup, {[css.clsFormPasswordGroup]: isPassword, [css.customErrorSpacing]: hideErrorMsg})}>
      <label  className={classNames(css.clsFormLabel, errors[name] && css.text_danger)} htmlFor={name}>{label}{required ? <span className={css.text_primary}>*</span>: null}</label>
      <input className={classNames(
               css.clsFormControl,
               errors[name] && css.clsBorderDanger,
               {[css.passwordInput]: isPassword}
             )} {...register(name)} id={name} placeholder={placeholder} type={isPassword && showPassword ? "text" : type}  maxLength={maxLength}
     onChange={(e) => {
      let value = e.target.value;
     
      if(numbers || decimal) {
        if (numbers && !decimal) {
          // Allow only whole numbers
          if (value.startsWith("00")) value = value.replace(/^0+/, "0");
          value = value.replace(/\D/g, ""); 
        } else if (!numbers && decimal) {
          // Allow only decimal format, e.g., ".12"
          value = value.replace(/[^0-9.]/g, "");
          
          // Ensure only one leading zero or decimal
          if (value.startsWith("00")) value = value.replace(/^0+/, "0");
          if (value.startsWith(".")) value = "0" + value;
    
          // Restrict to one decimal point and max two decimal places
          const parts = value.split(".");
          if (parts.length > 2) {
            value = parts[0] + "." + parts.slice(1).join("");
          }
          if (parts.length === 2) {
            parts[1] = parts[1].slice(0, 2); // Limit to 2 decimal places
            value = parts.join(".");
          }
        } else if (numbers && decimal) {
          // Allow both numbers and up to 2 decimal places
          value = value.replace(/[^0-9.]/g, "");
          
          // Ensure only one leading zero or decimal
          if (value.startsWith("00")) value = value.replace(/^0+/, "0");
          if (value.startsWith(".")) value = "0" + value;
    
          // Restrict to one decimal point and max two decimal places
          const parts = value.split(".");
          if (parts.length > 2) {
            value = parts[0] + "." + parts.slice(1).join("");
          }
          if (parts.length === 2) {
            parts[1] = parts[1].slice(0, 2); // Limit to 2 decimal places
            value = parts.join(".");
          }
        }
      }
     

      setValue(name, value);
      if(delayOnChangeValidation){
        const ignoreDelay = avoidDelay && avoidDelay(name);
        if(ignoreDelay) trigger(name)
        else delayedValidateField(name);
      } else {
        trigger(name);
      }
    }}
      />
      {isPassword && (
        <button
          type="button"
          className={classNames(css.passwordToggle, { 
            [css.placementWithCustomError]: hideErrorMsg, 
            [css.withCustomTogglePlacement]: successText || (name === 'confirmPassword' && errors[name])
          })}
          onClick={() => setShowPassword((prev) => !prev)}
        >
          <Tooltip title=""
            content={showPassword ? "Hide Password" :"Show Password"}
            position="top"
            bgColor="#128292"
            xOffset={showPassword ? -4 : -1}
            yOffset={-44}
            arrowOffset={70}
          >
          {showPassword ? <SVG icon="eyeOn" height='20' width='20' /> : <SVG icon="eyeOff" height='20' width='20' /> }
          </Tooltip>
        </button>
      )}
      {errors[name] && (isSubmitted || touchedFields[name]) && !hideErrorMsg && <div className={classNames(css.clsFormErrorText, css.text_danger)}>{errors[name].message}</div>}
      {successText && <p className={css.successText}>{successText}</p>}
      {showHint && touchedFields[name] && <div className={classNames(css.passwordhint)}>{showHint}</div>}
    </div>
  );
};

export default TextField;